import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,1277.85295 C784.703025,1277.85295 642.049017,1135.19894 642.049017,959.901965 C642.049017,784.60499 784.703025,641.950983 960,641.950983 C1135.29698,641.950983 1277.95098,784.60499 1277.95098,959.901965 C1277.95098,1135.19894 1135.29698,1277.85295 960,1277.85295 L960,1277.85295 Z M1908.3418,936.267609 C1720.64473,558.647825 1357.33274,324 960,324 C562.667255,324 199.355266,558.647825 11.6582027,936.267609 L0,959.901965 L11.6582027,983.536321 C199.355266,1361.15611 562.667255,1595.80393 960,1595.80393 C1357.33274,1595.80393 1720.64473,1361.15611 1908.3418,983.536321 L1920,959.901965 L1908.3418,936.267609 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconEyeSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconEyeSolid, _Component);

  var _super = _createSuper(IconEyeSolid);

  function IconEyeSolid() {
    _classCallCheck(this, IconEyeSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconEyeSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconEye",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconEyeSolid.displayName = "IconEyeSolid";
  return IconEyeSolid;
}(Component);

IconEyeSolid.glyphName = 'eye';
IconEyeSolid.variant = 'Solid';
IconEyeSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconEyeSolid;
export { IconEyeSolid };